import React, { useEffect, useState } from "react";
import { Content, Body, BodyImage, EditPerfilFirstLineFields, DefaultInputInclude, CheckoutInputInclude, CopyIconStyled } from "./styles";
import { Button, Checkbox, DefaultInput, DefaultSelect, IconInput } from "ui-kit-takeat";
import AvatarInputGd from "views/components/AvatarInputGd";
import { Col, Row } from "reactstrap";
import FileInput from "../../../../components/FileInput";
import { FaCheck, FaCopy } from "react-icons/fa";
import apiGd from "services/apiGd";

function EditProfile({
    hasNickname,
    setHasNickname,
    name,
    token,
    id,
    restaurantData,
    setRestaurantData,
    setInputSheet,
    setBuyerAddressSheet,
    buyerAddressSheet,
    users,
    sendInputsExcel,
    sendBuyerAddressExcel,
}) {
  const [listOfUserResponsible, setListOfUserResponsible] = useState([]);
  const [userResponsible,setUserResponsible] = useState({
    value:'',
    label:''
  });
  const [animatingIcon, setAnimatingIcon] = useState(null);

  const handleChange = (field, value) => {
    setRestaurantData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (users && users.length) {
      setListOfUserResponsible(users);
    }
  }, [users]);

  useEffect(()=>{
    const user = listOfUserResponsible.find((user)=> user.value === restaurantData.responsible_user_id);
    setUserResponsible(user);

    
  },[restaurantData,listOfUserResponsible])

  async function downloadInputsModel() {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    };

    const url =
      'https://takeat-imgs.takeat.app/Modelo_Insumos.xlsx';

    fetch(url)
      .then(response => response.blob())
      .then((blob) => downloadFile(blob, 'Modelo_Insumos.xlsx'))
  }

  async function downloadBuyerAddressModel() {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    };

    const url =
      'https://takeat-imgs.takeat.app/ModeloPlanilhaClientes.xlsx';

    fetch(url)
      .then(response => response.blob())
      .then((blob) => downloadFile(blob, 'ModeloPlanilhaClientes.xlsx'))
  }

  function downloadFile(data, filename) {
    const href = URL.createObjectURL(data);

    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  function toggleHasNickname(){
    setHasNickname(!hasNickname)
  }

  function handleCopy(copy) {
    navigator.clipboard.writeText(copy);
  }

  function handleCopyWithAnimation(fieldName, value) {
    setAnimatingIcon(fieldName);
    handleCopy(value);
    setTimeout(() => setAnimatingIcon(null), 400);
  }

  return (
    <Content>
      <Col>
        <span style={{ fontFamily: 'Poppins', fontSize: 24, fontWeight: 600 }}>
          Editar perfil
        </span>
        <Body>
          <EditPerfilFirstLineFields>
            <DefaultInputInclude borderColor='#cdcdcd'>
              <span>E-mail</span>
              <IconInput
                icon={<CopyIconStyled isAnimating={animatingIcon === 'email'} onClick={() => handleCopyWithAnimation('email', restaurantData?.email)}><FaCopy /></CopyIconStyled>}
                value={restaurantData?.email}
                onChange={(e) => handleChange('email', e.target.value)}
                containerStyles={{ gridArea: "email" }}
              />
            </DefaultInputInclude>
            <DefaultInputInclude>
              <DefaultInput
                title="Telefone"
                value={restaurantData?.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
                containerStyles={{ gridArea: "phone" }}
              />
            </DefaultInputInclude>
            <DefaultInputInclude>
              <DefaultInput
                title="Whatsapp"
                value={restaurantData?.owner_wpp}
                onChange={(e) => handleChange('owner_wpp', e.target.value)}
                containerStyles={{ gridArea: "whatsapp" }}
              />
            </DefaultInputInclude>
          </EditPerfilFirstLineFields>
          <DefaultSelect
            label="Usuário responsável"
            options={listOfUserResponsible}
            value={userResponsible}
            onChange={(e)=> handleChange('responsible_user_id',e.value)}
            containerStyles={{ gridArea: "responsavel"}}
            controlStyles={{ height: 48 }}
          />
          <DefaultInput
            title="Instagram"
            value={restaurantData?.instagram}
            onChange={(e) => handleChange('instagram', e.target.value)}
            containerStyles={{ gridArea: "instagram" }}
          />
        </Body>
       <Col>
        <Row style={{ marginBottom: '5px' }}>
          <Col md="10" style={{ paddingLeft: '5px', paddingRight: '3px' }}>
            <FileInput
              label="Insumos"
              name="inputs_sheet"
              onModelClick={() => downloadInputsModel()}
              onChange={(e) => setInputSheet(e.target.files[0])}
            />
          </Col>

          <Col
            md="2"
            style={{
              display: 'flex',
              padding: '0px 5px 0px 3px',
            }}
          >
            <Button
              title="Enviar"
              style={{
                margin: '0px 0px 10px 0px',
                padding: '12px 14px',
                alignSelf: 'end',
              }}
              onClick={sendInputsExcel}
               buttonColor="#7a7a7a"
            >
              <FaCheck />
            </Button>
          </Col>
        </Row>
        <Row style={{ marginBottom: '5px' }}>
          <Col md="8" style={{ paddingLeft: '5px', paddingRight: '3px' }}>
            <FileInput
              label="Clientes/Endereços"
              name="buyer_sheet"
              onModelClick={downloadBuyerAddressModel}
              onChange={(e) => {
                setBuyerAddressSheet((data) => ({ ...data, file: e.target.files[0] }))
              }}
            />
          </Col>

          <Col
            md="2"
            style={{
              display: 'flex',
              padding: '0px 5px 0px 3px',
            }}
          >
            <DefaultInput
              title="DDD"
              style={{ height: 42, padding: '6px 10px' }}
              value={buyerAddressSheet?.ddd}
              onChange={(e) => {
                const ddd = e.target.value;
                setBuyerAddressSheet((data) => ({ ...data, ddd }));
              }}
            />
          </Col>
          <Col
            md="2"
            style={{
              display: 'flex',
              padding: '0px 5px 0px 3px',
            }}
          >
            <Button
              title="Enviar"
              style={{
                margin: '0px 0px 10px 0px',
                padding: '12px 14px',
                alignSelf: 'end',
              }}
              onClick={sendBuyerAddressExcel}
              buttonColor="#7a7a7a"
            >
              <FaCheck />
            </Button>
          </Col>
        </Row>

       </Col>
      </Col>
    </Content>
  );
}

export default EditProfile;
